import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, switchMap, take } from 'rxjs/operators';

import * as fromAuth from '../state/auth.actions';
import * as fromCore from '../state/index';
import * as fromRoot from '../state/app.state';
import { UserState } from '../state/auth.reducer';

/**
 * Holds routing until the session check has completed, so no page renders
 * with an unknown user. The APP_INITIALIZER auth bootstrap owns the token
 * verification; when it has not run yet this only dispatches authCheck and
 * waits for isAuthChecked. The redirect of an anonymous visitor is the
 * MinAccessLevelGuard's and the authCheck effect's job, not this resolver's.
 */
export const authenticationResolver: ResolveFn<boolean> = () => {
  const store = inject<Store<fromRoot.AppState>>(Store);
  return store.pipe(
    select(fromCore.selectAuth),
    take(1),
    switchMap((userState: UserState): Observable<boolean> => {
      if (!userState.isAuthChecked) {
        store.dispatch(fromAuth.authCheck());
      }
      return store.pipe(
        select(fromCore.selectAuth),
        map((state: UserState) => state.isAuthChecked),
        first((checked: boolean) => checked === true),
      );
    }),
  );
};
